
import { FaRegTrashAlt } from "react-icons/fa"
import { Tooltip } from "components/Core"

interface ITrashButton {
  onClick: () => void
  label?: string
}

const TrashButton = ({ onClick, label = "" }: ITrashButton) => {
  return (
    <Tooltip content="Eliminar">
      <button
        type="button"
        onClick={onClick}
        className="flex bg-[#FF1F620D] hover:opacity-70 border border-transparent hover:border-[#FF0F00] px-4 py-2 rounded-lg cursor-pointer"
      >
        <FaRegTrashAlt className="text-xl font-semibold text-[#FF0F00]" />
        {label && (
          <span  className="text-[#FF0F00] text-base font-medium ml-1">{label}</span>
        )}
      </button>
    </Tooltip>
  )
}

export default TrashButton
